<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <!-- gofix-default-table -->
                        <gofix-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="detailItem"
                            ref="gofixTable">
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'master-notification-templates',
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['master_notification_templates']));
            return {
                tableConfig:{
                    name: 'contract-notification-master',
                    controls:{
                        create: false,
                        delete: false,
                        update: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "module",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: 'module',
                            label: 'Module',
                            thStyle: "width:170px",
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'title',
                            label: 'Title',
                            thStyle: "width:170px",
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'event_trigger_name',
                            label: 'Event Trigger',
                            thStyle: "width:170px",
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'medium',
                            label: 'Medium',
                            isActive: 1,
                            thStyle: "width:110px",
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'recipient_remark',
                            label: 'Recipient Remark',
                            isActive: 1,
                            thStyle: "width:200px",
                            isFilter: true,
                            sorting: true
                        }
                    ]
                },
                tableItems:[],
                modals: {
                    clone: {
                        open: false,
                        allSelect:true,
                        list:[],
                        select:[]
                    }
                }
            }
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contract_id = { type: "null", value: null, function: "=", with: [] };
                await this.$store.dispatch("NotificationTemplateController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of master notification templates", "danger");
                        reject();
                    })
            },
            detailItem(item) {
                
                if ( window.location.href.includes('v2') ) {
                    this.$router.push(`/v2/config-notification/${item.id}`).catch(err => {})
                    return;
                }
                
                this.$router.push(`/settings/config-notification/${item.id}`).catch(err => {})
            },
        }
    }
</script>